import axios from "axios";
import { isValid } from "./utils";
import showToast from "./toastyService";

const base_url = window.globalConfig.SERVER_URL;

export async function GetLogin(user, password) {
  if (!isValid(user) || !isValid(password)) {
    throw new Error("Usuário ou senha inválidos");
  }

  try {
    const response = await axios.post(
      `${base_url}/auth/login`,
      {
        email: user,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message || error.message || "Erro desconhecido";
    showToast("error", msg);
    throw error;
  }
}

export async function GetApi(url) {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${base_url}/${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
    });

    if (response?.data?.success === false) {
      showToast("error", "Erro");
      throw response;
    }
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }

    const msg =
      error?.response?.data?.message || error.message || "Erro desconhecido";
    showToast("error", msg);
    throw error;
  }
}

export async function PostApi(url, data) {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${base_url}/${url}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
    });

    if (response?.data?.success === false) {
      showToast("error", "Erro");
      throw response;
    }
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }

    const msg =
      error?.response?.data?.message || error.message || "Erro desconhecido";
    showToast("error", msg);
    throw error;
  }
}

export async function PutApi(url, id, data) {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(`${base_url}/${url}/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
    });

    if (response?.data?.success === false) {
      showToast("error", "Erro");
      throw response;
    }

    showToast("success", response.data.msgRet || "Sucesso");
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }

    const msg =
      error?.response?.data?.message || error.message || "Erro desconhecido";
    showToast("error", msg);
    console.log(error);
  }
}

export async function PutPass(data) {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(`${base_url}/auth/change-password`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
    });

    if (response?.data?.success === false) {
      showToast("error", "Erro");
      throw response;
    }

    showToast("success", response.data.msgRet || "Sucesso");
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }

    const msg =
      error?.response?.data?.message || error.message || "Erro desconhecido";
    showToast("error", msg);

    throw error;
  }
}

export async function DeleteApi(url, id) {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.delete(`${base_url}/${url}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
    });

    if (response?.data?.success === false) {
      showToast("error", "Erro");
      throw response;
    }

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }

    const msg =
      error?.response?.data?.message || error.message || "Erro desconhecido";
    showToast("error", msg);
    throw error;
  }
}
